export default __webpack_public_path__ + "static/media/ai.b13e3de6.jpg";